import React, {useContext, useState} from 'react';
import {Button, message, Modal, Tooltip} from 'antd';
import SelectFileToUpload from './SelectFileToUpload';
import {sideMenuContext} from '../../../router/IndexRouter';
import {saveAs} from 'file-saver';
import {GetApiMethod, PostToJava, RealtimeGetMethod} from './ApiMethod';

const ImportTableModal = ({uploadUrl, incrementId, templateUrl, titleText, getApi, tableTitle, duplicateApi}) => {
	const [open, setOpen] = useState(false);
	const [excelPath, setExcelPath] = useState('');
	const {
		fileList,
		setFileList,
		setDataSource,
		setCopyDataSource,
	} = useContext(sideMenuContext);
	const [isLoading, setIsLoading] = useState(false);
	const [okText, setOkText] = useState('开始导入');

	const showModal = () => {
		setOpen(true);
	};

	const handleOk = async () => {
		if (fileList.length === 0) {
			message.warning('请先上传Excel文件');
		} else {
			await handleImport();
		}
	};

	const handleImport = async () => {
		setOkText('正在导入...');
		setIsLoading(true);
		// 将列表中的数据去重
		const postData = {
			excelTitle: tableTitle.join('&&'),
			excelPath: excelPath,
			incrementId: incrementId,
			titleText: titleText,
		};
		PostToJava(uploadUrl, postData).then(res => {
			if (res?.data.code === 1) {
				setIsLoading(false);
				setOkText('导入成功');
				message.success('导入成功');
				RealtimeGetMethod(duplicateApi).then((data) => {
					// console.log("duplicate  ", data)
					if (data?.length > 0) {
						message.info(`成功删除了 ${data?.length} 条重复记录`);
					}
					setTimeout(() =>
						GetApiMethod({getApi, setDataSource, setCopyDataSource}), 1000);
				});
			} else {
				setIsLoading(false);
				setOkText('导入失败');
				// console.log(':', res);
				message.error(res?.data.result.msg);
			}
		});
	};

	const handleCancel = () => {
		setOpen(false);
		setOkText('开始导入');
		setFileList([]);    // 将选择的 Excel 列表清空
	};

	// 下载模板文件
	const downloadFile = async () => {
		try {
			const response = await fetch(templateUrl);
			if (response.ok) {
				const blob = await response.blob();
				saveAs(blob, templateUrl.split('/').pop());
			} else {
				message.error('网络请求异常.');
			}
		} catch (error) {
			console.error('模板文件下载失败:', error);
		}
	};

	// 获取上传后的 Excel 文件地址
	const getExcelPath = (url) => {
		setExcelPath(url);
	};

	return (
		<>
			<Button type="default" onClick={() => showModal()} style={{marginLeft: 8}}>导入</Button>
			<Modal
				width={550}
				title={titleText}
				open={open}
				confirmLoading={isLoading}
				onOk={handleOk}
				onCancel={handleCancel}
				okText={okText}
				okButtonProps={{disabled: okText !== '开始导入'}}
			>
				<p>1、导入信息前请<span style={{color: 'red'}}>先下载模板</span></p>
				<p>2、<span style={{color: 'red'}}>禁止修改表头</span>，并按<span style={{color: 'red'}}>表头内容</span>填写数据
				</p>
				<p>3、导入前请将<span style={{color: 'red'}}>不需要的历史数据</span>删除
				</p>
				<Tooltip title="下载模板前请认真阅读上面的文字" color={'cyan'} placement="right" key={'cyan'}>
					<Button
						type="link" onClick={() => downloadFile()}
						style={{
							marginLeft: -15,
							marginBottom: 10,
						}}>下载模板</Button>
				</Tooltip>
				<hr></hr>
				<SelectFileToUpload uploadExcelPath={getExcelPath}/>
			</Modal>
		</>
	);
};

export default ImportTableModal;